<template>
  <v-dialog
    v-model="showModal"
    persistent
    width="700px"
  >
    <v-card
      elevation="0"
      color="#ffff"
    >
      <v-card-title>
        <p class="process-header">
          Issue Status
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="checkout-details">
            <v-radio-group
              v-model="issueStatus"
              row
              class="field-text-style"
              light
              :rules="[(v) => !!v || 'This field is required']"
              @change="isIssueStatusChanged"
            >
              <v-radio
                label="Pending"
                value="pending"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Pending</span>
                </template>
              </v-radio>
              <v-radio
                label="Completed"
                value="completed"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Completed</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-textarea
              v-if="showReasonField"
              ref="status"
              v-model="pendingReason"
              dense
              :rules="issueStatus === 'pending' ? [(v) => !!v || 'This field is required'] : []"
              filled
              class="field-text-style"
              hint="Only required if Issue Status is 'Pending'."
              persistent-hint
              color="#000000"
              light
              outlined
              label="Reason*"
            />
            <v-textarea
              v-if="showRootCauseField"
              ref="status"
              v-model="rootCause"
              dense
              :rules="issueStatus === 'completed' ? [(v) => !!v || 'This field is required'] : []"
              filled
              class="field-text-style"
              hint="Only required if Issue Status is 'Completed'."
              persistent-hint
              color="#000000"
              light
              outlined
              label="Root Cause of Issue*"
            />
          </div>
        </v-form>
        <v-card-actions>
          <v-spacer /><v-btn
            class="next-style"
            elevation="0"
            @click="issueStatusGathered()"
          >
            {{ buttonName }}
          </v-btn>
          <v-btn
            class="cancel-style"
            elevation="0"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <centre-spinner :loading="loading" />
  </v-dialog>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';
export default {
  name: 'IssueStatus',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    loading: false,
    valid: false,
    showModal: true,
    issueStatus: 'pending',
    pendingReason: null,
    rootCause: null,
    showReasonField: false,
    showRootCauseField: false,
  }),
  computed: {
      appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
    checkOutType () {
      return this.$store.getters['devices/getCheckOutType'];
      },
      deviceData () {
      return this.$store.getters.getDeviceData;
    },
    buttonName () {
      return this.checkOutType === 'cost-shift' ? 'Cost-Shift' : 'Check-out';
    },
    },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('cancel');
      }
    },
  },
  mounted () {
    this.isIssueStatusChanged();
    this.getCheckInRecords();
  },
    methods: {
      async getCheckInRecords () {
       await this.$store.dispatch('devices/fetchUsersCurrentCheckInDetails');
    },
      async issueStatusGathered () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        if (this.checkOutType === 'cost-shift') {
          await this.$store.dispatch('devices/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: 'cost-shift',
              checkout_kiosk_id: this.deviceData.id,
            },
            checkInId: this.appUserCheckInRecord.id,
          });
        await this.$store.dispatch('devices/sendIssueStatus', {
          statusDetails: {
            status: this.issueStatus,
          pendingReason: this.pendingReason,
          rootCause: this.rootCause,
          },
          checkInId: this.appUserCheckInRecord.id,
        })
        .then(() => {
         this.$emit('success');
        },
      );
        return;
      }
        await this.$store.dispatch('devices/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: 'manual-onsite',
              checkout_kiosk_id: this.deviceData.id,
            },
            checkInId: this.appUserCheckInRecord.id,
          });
        await this.$store.dispatch('devices/sendIssueStatus', {
          statusDetails: {
            status: this.issueStatus,
          pendingReason: this.pendingReason,
          rootCause: this.rootCause,
          },
          checkInId: this.appUserCheckInRecord.id,
        }).then(() => {
          this.loading = true;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-out completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          setTimeout(() => {
          this.$store.dispatch('devices/workerLogout');
          this.$store.dispatch('kioskUserLogout');
          this.$router.push({ name: 'DeviceCheckInCheckOut' });
        }, 1000);
        });
      },
      isIssueStatusChanged () {
        if (this.issueStatus === 'completed') {
          this.pendingReason = null;
          this.showReasonField = false;
          this.showRootCauseField = true;
        } else {
          this.rootCause = null;
          this.showRootCauseField = false;
          this.showReasonField = true;
        }
      },
      cancel () {
        this.$emit('closed');
      },
    },
};
</script>

<style scoped>
.checkin .mdi-checkbox-marked::before{
  color: #37474F !important;
  caret-color: #37474F !important;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
